import { useSelector } from "react-redux"
import React, { useEffect, useState } from 'react';
import { uploadFileData } from "../../services/upload-files.service";
import { useRef } from "react";

const Scope1 = ({ month, year, facility_id, setIsMounted }) => {
    const loading = useSelector((state) => state.facilities.loading);
    const scope1Data = useSelector((state) => state.facilities.data.facilitiesdatapoint.ghg);
    const [data, setData] = useState(scope1Data);
    const [editableRowId, setEditableRowId] = useState(null);
    const [attachment, setAttachment] = useState()
    const [formDatas, setFormDatas] = useState()
    const [isloading, setIsLoading] = useState(false);

    const inputRef = useRef();

    useEffect(() => {
        const handleClickOutside = (event) => {
            const isActionButton =
                event.target.type === 'file' || event.target.classList.value == "fa-regular fa-pen-to-square";

            // Exclude Save and Cancel buttons from setting editableRowId to null
            if (!isActionButton && editableRowId !== null && !inputRef.current.contains(event.target)) {
                // Check if the clicked element is not the Save or Cancel button based on content
                const buttonText = event.target.classList.value.toLowerCase();
                if (buttonText != 'fa-solid fa-check' && buttonText != 'fa-solid fa-ban') {
                    setEditableRowId(null);
                }
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [editableRowId]);

    useEffect(() => {
        setData(scope1Data);
    }, [scope1Data]);

    const handleEditClick = (id) => {
        setEditableRowId(id);

    };

    const handleEditDblClick = (id) => {
        setEditableRowId(id);
    };

    const handleSaveClick = async (idx) => {
        setFormDatas({
            data_point_id: data['Scope 1'][idx].id,
            amount: data['Scope 1'][idx].amount ? data['Scope 1'][idx].amount : 0,
            energy: data['Scope 1'][idx].energy ? data['Scope 1'][idx].energy : 0,
            emission: data['Scope 1'][idx].emission ? data['Scope 1'][idx].emission : 0,
            facility_id: facility_id,
            month: month,
            year: year,
            attachment: attachment /*? attachment : data['Scope 1'][idx].attachment*/
        }
        );
        setEditableRowId(null);
    };


    useEffect(() => {
        if (formDatas) {
            setIsLoading(true)
            try {
                uploadFileData(formDatas, "facilities/datapoint").then((res) => {
                    if (res.status === 200) {
                        setIsMounted(true)
                        setFormDatas(null)
                        setAttachment(null)
                        setIsLoading(false)
                    }
                });
            } catch (error) {
                console.error(error);
            }
        }
    }, [formDatas]);

    const handleCancelClick = () => {
        setEditableRowId(null);
    };

    const formatCurrency = (value) => {
        const stringValue = value.toString();
        const parts = stringValue.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

        if (parts.length === 1) {
            parts.push('00');
        } else if (parts[1].length === 1) {
            parts[1] += '0';
        }

        return parts.join('.');
    };

    const handleInputChange = (event, id, measure) => {
        const { name, value } = event.target;

        setData((prevData) => ({
            ...prevData,
            'Scope 1': prevData['Scope 1'].map((item) => {
                if (item.id === id) {
                    const updatedItem = { ...item, [name]: value };

                    if (name === "amount" && (!isNaN(parseFloat(value)) || value == "")) {
                        const numericValue = value.replace(/[^\d.]/g, '');
                        const emission = (numericValue * measure).toFixed(2);
                        updatedItem.emission = formatCurrency(emission);

                        let values = value.replace(/[^\d.]/g, '');
                        const stringValue = values.toString();
                        const parts = stringValue.split('.');
                        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                        updatedItem.amount = parts.join('.')
                    }

                    return updatedItem;
                }
                return item;
            }),
        }));
    };


    const handleFileChange = (event, id) => {
        const file = event.target.files[0];
        setAttachment(file)
    };


    if (isloading) {
        return (
            <>
                <main className="col-md-12">
                    <h1 className="h2 py-2"> <i class="fa-solid fa-spinner fa-spin"></i></h1>
                </main>
            </>
        )
    }

    return (
        <>
            {data['Scope 1'] && data['Scope 1'].length > 0 ? (
                data['Scope 1'].map((curData, idx) => {
                    const { id, name, amount, unit, emission, attachment, measure } = curData;

                    return (
                        <tr key={id}>
                            <td>{name ? name : "--"}</td>
                            <td className="clickable" onDoubleClick={() => handleEditDblClick(id)} disabled={editableRowId !== null}>
                                {editableRowId === id ? (
                                    <input
                                        type="text"
                                        name="amount"
                                        value={amount}
                                        ref={inputRef}
                                        onChange={(e) => handleInputChange(e, id, measure)}
                                    />
                                ) : (
                                    <span title="Double click to edit">{amount}</span>
                                )}
                            </td>
                            <td>{unit}</td>
                            <td>
                                {emission}
                            </td>
                            <td>
                                {editableRowId === id ? (
                                    <input
                                        type="file"
                                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                        onChange={(e) => handleFileChange(e, id)}
                                    />
                                ) : (
                                    <span>
                                        <i className="fa-solid fa-paperclip"></i>
                                        {attachment ? (
                                            <a href={attachment} target="_blank" rel="noopener noreferrer">
                                                <i className="fa fa-download" aria-hidden="true"></i>
                                            </a>
                                        ) : (
                                            ""
                                        )}
                                    </span>
                                )}
                            </td>
                            <td>
                                {editableRowId === id ? (
                                    <>
                                        <button className="custom-button" onClick={() => handleSaveClick(idx)}><i className="fa-solid fa-check"></i></button>
                                        <button className="custom-button" onClick={handleCancelClick}><i className="fa-solid fa-ban"></i></button>
                                    </>
                                ) : (
                                    <button className="custom-button" onClick={() => handleEditClick(id)} disabled={editableRowId !== null}><span><i className="fa-regular fa-pen-to-square"></i></span></button>
                                )}
                            </td>
                        </tr>
                    );
                })
            ) : (
                <tr>
                    <td colSpan="6">No data available.</td>
                </tr>
            )}
        </>
    );
};

export default Scope1;
